export default function Features() {
  return (
    <section id="features" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="mb-16">
          <p className="text-gray-500 text-sm font-light mb-3 tracking-wide">Key Features</p>
          <h2 className="text-5xl md:text-6xl font-extrabold text-gray-900">
            Why Choose<br />
            Our Products
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="bg-gray-50 rounded-2xl p-10">
            <div className="w-12 h-12 flex items-center justify-center mb-6">
              <i className="ri-shield-check-line text-gray-900 text-5xl"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4">Advanced Security</h3>
            <p className="text-sm text-gray-600 leading-relaxed">
              Military-grade encryption and advanced security protocols protect your data and online activities. Our VPN ensures complete anonymity and shields you from cyber threats with cutting-edge technology.
            </p>
          </div>

          <div className="bg-gray-50 rounded-2xl p-10">
            <div className="w-12 h-12 flex items-center justify-center mb-6">
              <i className="ri-dashboard-line text-gray-900 text-5xl"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4">Optimized Performance</h3>
            <p className="text-sm text-gray-600 leading-relaxed">
              Experience lightning-fast speeds and seamless performance. Our applications are optimized to use minimal system resources while delivering maximum efficiency and responsiveness on all iOS devices.
            </p>
          </div>

          <div className="bg-gray-50 rounded-2xl p-10">
            <div className="w-12 h-12 flex items-center justify-center mb-6">
              <i className="ri-smartphone-line text-gray-900 text-5xl"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4">Intuitive Interface</h3>
            <p className="text-sm text-gray-600 leading-relaxed">
              Clean, modern design that's easy to navigate. Our user-friendly interfaces make complex features accessible to everyone, ensuring a smooth and enjoyable experience from the first tap.
            </p>
          </div>

          <div className="bg-gray-50 rounded-2xl p-10">
            <div className="w-12 h-12 flex items-center justify-center mb-6">
              <i className="ri-refresh-line text-gray-900 text-5xl"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4">Regular Updates</h3>
            <p className="text-sm text-gray-600 leading-relaxed">
              Continuous improvements and new features. We regularly update our applications to ensure compatibility with the latest iOS versions and to introduce innovative features based on user feedback.
            </p>
          </div>

          <div className="bg-gray-50 rounded-2xl p-10">
            <div className="w-12 h-12 flex items-center justify-center mb-6">
              <i className="ri-global-line text-gray-900 text-5xl"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4">Global Coverage</h3>
            <p className="text-sm text-gray-600 leading-relaxed">
              Access servers worldwide for optimal connectivity. Our VPN service offers extensive global coverage with high-speed servers strategically located across multiple countries for reliable connections.
            </p>
          </div>

          <div className="bg-gray-50 rounded-2xl p-10">
            <div className="w-12 h-12 flex items-center justify-center mb-6">
              <i className="ri-customer-service-line text-gray-900 text-5xl"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4">Expert Support</h3>
            <p className="text-sm text-gray-600 leading-relaxed">
              Dedicated customer support team ready to assist. Our knowledgeable support staff is available to help you with any questions or issues, ensuring you get the most out of our applications.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}